import PropTypes from "prop-types";
import React from "react";
import Dropdown from "./Dropdown";
import ClickOutside from "../ClickOutside";
import TabOutside from "../TabOutside";

const returnFocusToWidgetIcon = e => {
  e.preventDefault();
  const focusTarget = document.getElementById("accountIcon");
  return focusTarget && focusTarget.focus();
};

const DropdownContainer = ({
  name,
  isOpen,
  isHidden,
  open,
  openComplete,
  close,
  children,
  header,
  body
}) => {
  return (
    <TabOutside disabled={!isOpen} callback={close}>
      <ClickOutside
        disabled={!isOpen}
        callback={close}
        validPropagationTargets={["#chrome-header", "#chrome-breadcrumb"]}
      >
        <Dropdown
          name={name}
          isOpen={isOpen}
          isHidden={isHidden}
          open={open}
          openComplete={openComplete}
          onCloseWithMouse={close}
          onCloseWithKeyboard={e => {
            close();
            returnFocusToWidgetIcon(e);
          }}
          header={header}
          body={body}
        >
          {children}
        </Dropdown>
      </ClickOutside>
    </TabOutside>
  );
};

DropdownContainer.propTypes = {
  name: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
  isHidden: PropTypes.bool,
  open: PropTypes.func,
  openComplete: PropTypes.func,
  close: PropTypes.func,
  children: PropTypes.node,
  header: PropTypes.node,
  body: PropTypes.node
};

export default DropdownContainer;



// WEBPACK FOOTER //
// ./template/components/Dropdown/DropdownContainer.js